module.exports = __webpack_public_path__ + "./static/img/logo-icon.62fcc823fbefa7baec311475730920c4.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/logo-icon.png
// module id = ./client/src/assets/img/logo-icon.png
// module chunks = 0